const Invoicing = () => {
  return (
    <div className="welcome-portal" style={{ textAlign: "center", padding: "48px 0" }}>
      {/* Enhanced Coming Soon icon */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="110"
        height="110"
        viewBox="0 0 110 110"
        style={{ display: "block", margin: "0 auto 24px" }}
      >
        <defs>
          <radialGradient id="glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#fffbe7" stopOpacity="1" />
            <stop offset="100%" stopColor="#ffe082" stopOpacity="0.3" />
          </radialGradient>
          <linearGradient id="main" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#1976D2" />
            <stop offset="100%" stopColor="#64b5f6" />
          </linearGradient>
        </defs>
        {/* Glow */}
        <circle cx="55" cy="55" r="52" fill="url(#glow)" />
        {/* Main circle */}
        <circle cx="55" cy="55" r="44" stroke="url(#main)" strokeWidth="4" fill="#fff" />
        {/* Clock hands */}
        <path d="M55 35v22l16 9" stroke="url(#main)" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
        {/* Dotted circle */}
        <circle cx="55" cy="55" r="34" stroke="#1976D2" strokeWidth="2" strokeDasharray="4 6" fill="none"/>
        {/* Sparkles */}
        <g>
          <circle cx="85" cy="35" r="2" fill="#ffd600" />
          <circle cx="25" cy="75" r="1.5" fill="#ffd600" />
          <circle cx="70" cy="90" r="1.2" fill="#ffd600" />
          <circle cx="40" cy="20" r="1.5" fill="#ffd600" />
        </g>
        {/* Small star */}
        <polygon points="55,18 57,23 62,24 58,27 59,32 55,29 51,32 52,27 48,24 53,23" fill="#ffd600" />
      </svg>
      <h2 style={{ color: "#1976D2", fontWeight: 700, letterSpacing: 1 }}>Coming Soon...</h2>
      <p style={{ color: "#555", fontSize: "1.1rem" }}>
        We’re working on something exciting — launching soon.
      </p>
    </div>
  );
};

export default Invoicing;